import React, { useCallback } from 'react';

import MerchantSelect from '@components/operator/MerchantSelect';
import ReplaceSkuWizard from '@components/shared/products/ReplaceSkuWizard';
import { useOperatorData } from '@contexts/operator/OperatorDataContext';
import { useOperatorProductService } from '@hooks/operator/products/useOperatorProductService';
import PageHeader from '@shared/PageHeader';
import { useNavigate } from 'react-router-dom';

function ReplaceSkuContent() {
  const navigate = useNavigate();
  const { merchantId } = useOperatorData();
  const productService = useOperatorProductService({ merchantId });

  const handleSuccess = useCallback(() => {
  }, []);

  const handleCancel = useCallback(() => {
    navigate('/products');
  }, [navigate]);

  return (
    <div>
      <PageHeader items={['products', 'products.replace_sku']} />
      <ReplaceSkuWizard
        productService={productService}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
        extraParams={{ merchant_id: merchantId }}
      />
    </div>
  );
}

export default function ReplaceSku() {
  return (
    <MerchantSelect>
      <ReplaceSkuContent />
    </MerchantSelect>
  );
}
